var React = require('react');

function CtaArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill:none;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("g",{"id":"arrow","key":1},[React.createElement("path",{"id":"point","className":"cls-1","d":"M3.53.5H22.35V19.33","key":0}),React.createElement("line",{"id":"line","className":"cls-1","x1":"22.17","y1":"0.69","x2":"0.35","y2":"22.5","key":1})])]);
}

CtaArrow.defaultProps = {"id":"cta-arrow","data-name":"cta arrow","viewBox":"0 0 22.85 22.85"};

module.exports = CtaArrow;

CtaArrow.default = CtaArrow;
